var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProjectWebsite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: 75,
    height: 75,
    fill: "rgb(129,127,139)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59 2H5a3 3 0 0 0-3 3v54a3 3 0 0 0 3 3h54a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3zm1 57a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V12h56zM4 10V5a1 1 0 0 1 1-1h54a1 1 0 0 1 1 1v5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.29 6.29A1.033 1.033 0 0 0 6 7a1 1 0 0 0 .08.38.933.933 0 0 0 .21.33 1 1 0 0 0 1.42-1.42 1.047 1.047 0 0 0-1.42 0zM10.29 6.29A1.052 1.052 0 0 0 10 7a1.355 1.355 0 0 0 .02.2.636.636 0 0 0 .06.18.757.757 0 0 0 .09.18 1.576 1.576 0 0 0 .12.15 1.014 1.014 0 0 0 1.42 0l.12-.15a.757.757 0 0 0 .09-.18.636.636 0 0 0 .06-.18A1.355 1.355 0 0 0 12 7a1 1 0 0 0-1.71-.71zM14.29 6.29a1.014 1.014 0 0 0 0 1.42 1 1 0 0 0 1.42-1.42 1.047 1.047 0 0 0-1.42 0zM58 14H6v14h52zm-2 12H8V16h48zM24 30H6v28h18zm-2 26H8V32h14zM26 43h32V30H26zm2-11h28v9H28zM26 58h32V45H26zm2-11h28v9H28z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectWebsite);
export default __webpack_public_path__ + "static/media/project-website.e4079f057947b47985d63856e9e36e2c.svg";
export { ForwardRef as ReactComponent };